import {
  SideNav as SideNavComponent,
  SideNavProps as SideNavComponentProps,
  SideNavSection,
} from '@ui-components/neo.tax';

import { SideNavItem, type SideNavItemProps } from './SideNavItem';

interface SideNavSectionProps {
  title: string;
  items: SideNavItemProps[];
}

export type SideNavProps = Pick<SideNavComponentProps, 'footer' | 'variant' | 'open' | 'gap'> & {
  sections: SideNavSectionProps[];
};

export const SideNav = ({ footer, gap, open, sections, variant }: SideNavProps): React.ReactElement => (
  <SideNavComponent variant={variant} open={open} gap={gap} footer={footer}>
    {sections.map((section) => (
      <SideNavSection key={section.title} title={section.title}>
        {section.items.map((item) => (
          <SideNavItem
            key={item.id}
            icon={item.icon}
            id={item.id}
            title={item.title}
            to={item.to}
            isCompleted={item.isCompleted}
            subLinks={item.subLinks}
          />
        ))}
      </SideNavSection>
    ))}
  </SideNavComponent>
);
